import * as React from 'react';
import { Dispatch } from 'react-redux';
import { ActionType, CallbackAction, getOrFetchDriveItemMeta } from '../../containers/DriveItemList/actions';
import Page from '../../containers/Page';
import { PageType } from '../../containers/Page/constants';
import { share } from '../../containers/Share/actions';
import { StoreState } from '../../reducers';
import { Api } from '../../typings/api';

interface SharePageParams {
	driveItemId: string;
	page?: string;
}

interface SharePageProps {
	dispatch: Dispatch<StoreState>;
	params: SharePageParams;
}

const SharePage = ({ params: { driveItemId, page }, dispatch }: SharePageProps) => {

	React.useEffect(() => {
		const onLoad = async () => {
			if (driveItemId) {
				const driveItem: Api.DriveItem = await dispatch(getOrFetchDriveItemMeta(+driveItemId)) as Api.DriveItem;
				const callbackAction: CallbackAction = {
					type: ActionType.VIEW_DRIVE_ITEM,
					assetId: +driveItemId,
					page: page ? +page : undefined,
				};
				dispatch(share(
					[driveItem],
					undefined,
					undefined,
					callbackAction,
				));
			}
		};

		onLoad();
	}, [driveItemId]);

	return (
		<Page
			pageType={PageType.ParametersPage}
			title="messages.share"
		/>
	);
};

export default SharePage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SharePage/index.tsx